/**
 *
 * Preview
 *
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import Gallery from '../Gallery/index.jsx';

import GridView from './GridView.jsx';
import Inline from './Inline.jsx';
import parseFiles from './parseFiles.js';
import messages from './messages.js';
import ListDocuments from './ListDocuments.jsx';
import ShapedImage from './ShapedImage.jsx';

const MEDIAFILE_STATUS_QUEUED = 20;

function Preview(props) {
  const { files, inline, small, gallery, className, onChange, onDelete } = props;
  const [startIndex, setStartIndex] = useState(-1);

  if (!files || files.length === 0) {
    return null;
  }
  const parsedFiles = parseFiles(files);
  parsedFiles.media = [...parsedFiles.videos, ...parsedFiles.images];

  const MediaWrapper = inline ? Inline : GridView;
  const count = parsedFiles.media.length;
  const forceSquare = inline || small || (count > 1);
  const maxCount = 4;
  const media = inline ? parsedFiles.media : parsedFiles.media.slice(0, maxCount);
  const videoWarn = !inline && media.some((m) => m.type === 'video' && m.status === MEDIAFILE_STATUS_QUEUED);
  const overlay = (idx) => !inline && maxCount && count > maxCount && idx === maxCount - 1 ? `+ ${count - maxCount}` : '';
  const imgClass = small ? 'd-inline-block' : 'd-flex justify-content-center align-items-center bg-gray';
  const canClick = gallery && startIndex === -1;

  return (
    <div className={className}>
      <MediaWrapper count={small ? maxCount : Math.min(maxCount, count)} className="media-wrapper mb-4">
        {media.map((item, idx) => (
          <ShapedImage
            key={item.id}
            item={item}
            overlay={overlay(idx)}
            forceSquare={forceSquare}
            disabled={startIndex >= 0 && startIndex !== idx}
            onChange={onChange}
            onClick={canClick ? () => setStartIndex(idx) : undefined}
            role={canClick ? 'button' : undefined}
            onDelete={onDelete}
            className={imgClass}
          />
        ))}
      </MediaWrapper>
      {videoWarn && <Alert variant="warning" transition={false} className="mb-4"><FormattedMessage {...messages.slowVideos} /></Alert>}
      <ListDocuments files={parsedFiles.other} onDelete={onDelete} className="mb-4" />
      {gallery && startIndex >= 0
            && (
              <Gallery
                items={parsedFiles.media}
                startIndex={startIndex}
                onClose={() => setStartIndex(-1)}
              />
            )}
    </div>
  );
}

Preview.propTypes = {
  inline: PropTypes.bool,
  className: PropTypes.string,
  small: PropTypes.bool,
  files: PropTypes.array,
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
  gallery: PropTypes.bool,
  noRetry: PropTypes.bool,
};

export default Preview;
